import React from "react";

export default function Exposition() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      {/* ✅ Image centrée */}
      <img
        src="/images/exposition.jpg" // ⚡ mets ton image dans public/images/
        alt="Exposition"
        style={{
          maxWidth: "600px", // largeur maximale
          width: "100%",     // s’adapte aux petits écrans
          height: "auto",    // conserve le ratio
          marginBottom: "1.5rem",
        }}
      />

      {/* ✅ Texte sous l’image */}
      <p style={{ fontSize: "1.2rem", lineHeight: "1.6", maxWidth: "800px", margin: "0 auto" }}>
Plusieurs machines fantastiques de Séraphin Clerc sont exposées au Magasin où l’on ne vend rien:<br /> "J'aurais pu vous vendre" 
chez Jean-Manuel D'Andrès <br /> Rue d'Octodure 5 à Martigny (Valais-Suisse).<br />
Si vous êtes intéressé à exposer ces machines ou en faire l'acquisition (certaines sont à vendre), <br />
merci d'utiliser le formulaire de contact.  
      </p>
    </div>
  );
}
